//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Progress from '@/crowd_fund/Progress'
	export default {
		components:{
			Progress
		},
		props:['zcdata','zcuserid','zctoken','zcnickname'],
		data () {
			return {
				imgUrl:require('../assets/images/gongzhang.png')
			}
		},
		methods :{
			moneySplit (projectAlM) {
	            if(projectAlM<10000){
	              projectAlM = projectAlM +'元';
	            }else if(projectAlM>=10000&&projectAlM<100000000){
	              projectAlM =Math.floor(projectAlM/10000)+'万元';


	            }else if(projectAlM>=100000000){
	              projectAlM =Math.floor(projectAlM/100000000)+'亿元';
	            }
	            return projectAlM
	          },
			goDetail () {

				// this.$router.push('/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+this.zctoken)

				console.log(window.location.href,'这是当前跳转详情地址');
				if(this.isWeixinCient()){
					console.log('这是微信的跳转详情');
					console.log('/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken)
					if(this.zcdata.crowdId){
						this.$router.push('/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken)
					}else{
						this.$router.push('/zcprojectDetail/'+this.zcdata.crowdid+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken)
					}
				}else{
					// console.log('这是app的跳转详情')
					// console.log('{"title":"项目详情","url":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'","navbarHidden":"YES"}')
					// if(this.zcdata.crowdId){
					// 	window.navigation.pushPage('{"title":"项目详情","url":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+localStorage.getItem('zcnickname')+'/'+this.zctoken+'?histroy=black","navbarHidden":"YES"}');
					// }else{
					// 	window.navigation.pushPage('{"title":"项目详情","url":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zcuserid+'/'+this.zctoken+'?histroy=black","navbarHidden":"YES"}');
					// }

					if(this.zcdata.crowdId){
						this.$router.push('/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken)
					}else{
						this.$router.push('/zcprojectDetail/'+this.zcdata.crowdid+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken)
					}

				}
			}
		},
		mounted () {
			console.log(this.zcnickname,'111111111111111111111111')
		}

	}



// WEBPACK FOOTER //
// ./src/crowd_fund/compentList.vue